import FingerprintJS from '@fingerprintjs/fingerprintjs'

const fpPromise = FingerprintJS.load()

window.getFingerprint = async function getFingerprint() {
  const fp = await fpPromise
  let fingerprint = await fp.get()

  let input = document.getElementById("fingerprintid");
  if (input) {
    input.value = fingerprint.visitorId
  }

  return fingerprint;
}

window.getFingerprint();